"use client";

import React from "react";
import { Facebook, Instagram, Twitter, ArrowUp } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";
import { Link } from "@/components/common/Link";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
const defaultColumns = [{
  title: "Kelowna Office",
  links: [{
    label: "123 Industrial Way, BC",
    href: "#"
  }, {
    label: "+1 (250) 555-0199",
    href: "tel:+12505550199"
  }, {
    label: "kelowna@aremmetals.com",
    href: "mailto:kelowna@aremmetals.com"
  }]
}, {
  title: "New York Office",
  links: [{
    label: "500 Wall Street, NY 10005",
    href: "#"
  }, {
    label: "+1 (212) 555-0188",
    href: "tel:+12125550188"
  }, {
    label: "nyc@aremmetals.com",
    href: "mailto:nyc@aremmetals.com"
  }]
}];
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <>
        
        
      </>;
  }
  const columns = menuItems && menuItems.length > 0 ? menuItems : defaultColumns;
  return <>
      {columns.map((col: any, i: number) => <div key={col.id || i} data-index={i} className="space-y-6">
          <h3 className="font-default text-lg font-bold uppercase tracking-tighter text-foreground">
            {col.label || col.title}
          </h3>
          <ul className="space-y-4">
            {(col.children || col.links || []).map((link: any, j: number) => <li key={link.id || j} data-index={j}>
                <Link to={link.href || "#"} className="font-mono text-sm text-muted-foreground transition-colors hover:text-primary">
                  {link.label}
                </Link>
              </li>)}
          </ul>
        </div>)}
    </>;
}
export default function ShopnoFooter() {
  const scrollToTop = () => {
    if (typeof window !== "undefined") {
      window.scrollTo({
        top: 0,
        behavior: "smooth"
      });
    }
  };
  return <section data-section-id="228537" id="footer" className="bg-background pt-16 pb-8 text-foreground">
      <div className="container mx-auto px-4 md:px-6">
        <div className="mb-16 grid grid-cols-1 gap-12 md:grid-cols-2 lg:grid-cols-4 lg:gap-8">
          {}
          <div className="flex flex-col space-y-6">
            <Link to="/" className="inline-block w-fit">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1639953/img/shopno_logo_light.png" alt="Arem Metals" className="h-7 w-auto object-contain brightness-0 invert" />
            </Link>
            <p className="font-sans text-sm leading-relaxed text-muted-foreground">Arem Metals is a North American-based scrap metal trading company specializing in bulk export to global steel mills, sourcing high-volume HMS and shredded materials.<br /><br />Email: info@aremmetals.com<br />Phone: +1 250 899 4998<br /></p>
          </div>

          {}
          <MenuProvider menu_id="17" className="col-span-1 md:col-span-2 lg:col-span-2 grid grid-cols-1 sm:grid-cols-2 gap-12 lg:gap-8">
            <FooterMenuConsumer />
          </MenuProvider>

          {}
          <div className="flex flex-col space-y-8">
            
            
            
          </div>
        </div>

        <Separator className="mb-8 bg-secondary" />

        {}
        <div className="flex flex-col-reverse items-center justify-between gap-4 md:flex-row">
          <p className="font-sans text-xs uppercase tracking-widest text-muted-foreground">
            &copy; {new Date().getFullYear()} Arem Metals Trading. All rights reserved.
          </p>
          <Button variant="outline" size="sm" onClick={scrollToTop} className="group rounded-none border-secondary bg-transparent font-mono text-xs uppercase text-foreground hover:bg-primary hover:text-primary-foreground hover:border-primary">
            Back to Top
            <ArrowUp className="ml-2 size-4 transition-transform group-hover:-translate-y-1" />
          </Button>
        </div>
      </div>
    </section>;
}